import { render, staticRenderFns } from "./MenubarEnergy.vue?vue&type=template&id=b083a276&scoped=true&"
import script from "./MenubarEnergy.vue?vue&type=script&lang=js&"
export * from "./MenubarEnergy.vue?vue&type=script&lang=js&"
import style0 from "./MenubarEnergy.vue?vue&type=style&index=0&id=b083a276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b083a276",
  null
  
)

export default component.exports